// extracted by css-extract-rspack-plugin
export default {"header":"HnRSBBfGhg4ILpj1","paths":"yiy4n2Z3P_QNp8YH"};